/**
 * WorkflowProgress - Step progress indicator for IoT agentic onboarding
 */

import { CheckCircle2, Circle, Loader2 } from 'lucide-react';

interface WorkflowProgressProps {
  stepsCompleted: string[];
  stepsRemaining: string[];
  isProcessing?: boolean;
}

export default function WorkflowProgress({ stepsCompleted, stepsRemaining, isProcessing }: WorkflowProgressProps) {
  const total = stepsCompleted.length + stepsRemaining.length;
  const pct = total > 0 ? Math.round((stepsCompleted.length / total) * 100) : 0;

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 space-y-3">
      {/* Progress bar */}
      <div className="flex items-center gap-3">
        <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-600 rounded-full transition-all duration-500"
            style={{ width: `${pct}%` }}
          />
        </div>
        <span className="text-xs text-gray-500 font-medium w-10 text-right">{pct}%</span>
      </div>

      {/* Step list */}
      <div className="space-y-1.5">
        {stepsCompleted.map((step, i) => (
          <div key={`c-${i}`} className="flex items-center gap-2 text-sm">
            <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" />
            <span className="text-gray-700">{step}</span>
          </div>
        ))}
        {stepsRemaining.map((step, i) => (
          <div key={`r-${i}`} className="flex items-center gap-2 text-sm">
            {i === 0 && isProcessing ? (
              <Loader2 className="w-4 h-4 text-blue-500 animate-spin flex-shrink-0" />
            ) : (
              <Circle className="w-4 h-4 text-gray-300 flex-shrink-0" />
            )}
            <span className={i === 0 && isProcessing ? 'text-blue-700 font-medium' : 'text-gray-400'}>
              {step}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
